export { default } from "ember-stereo/-private/utils/untracked-object-cache";
